export * from './time-ago.pipe';
export * from './file-size.pipe';
export * from './to-jpg.pipe';
export * from './capitalize.pipe';



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/pipes/index.ts